<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    :rules="rules"
    label-width="120px"
    @handleConfirm="handleConfirm"
  >
    <el-col :span="22">
      <el-form-item :label="$t('SettingBaseDataCountry.table.countryCode')" prop="countryCode">
        <BjInput
          v-model="form.countryCode"
          :maxlength="MAX_LENGTH.DEFAULT"
          :disabled="isEdit"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="22">
      <el-form-item :label="$t('SettingBaseDataCountry.table.countryName')" prop="countryName">
        <BjInput
          v-model="form.countryName"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="22">
      <el-form-item :label="$t('SettingBaseDataCountry.table.countryAbbreviation')" prop="abbreviation">
        <BjInput
          v-model="form.abbreviation"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>

    <el-col :span="22">
      <el-form-item :label="$t('enableText')" prop="enabledFlag">
        <el-switch v-model="form.enabledFlag" :active-value="1" :inactive-value="0" />
      </el-form-item>
    </el-col>
  </BjDrawerForm>
</template>
<script>
import { baseDataApi } from '@/api';
const getDefaultForm = () => {
  return {
    _innerMap: {},
    abbreviation: null,
    countryCode: null,
    countryId: null,
    countryName: null,
    enabledFlag: 0,
    quickIndex: null,
    tenantId: 'default',
  };
};

export default {
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        countryCode: [{ required: true, message: this.$t('SettingBaseDataCountry.table.countryCodeText'), trigger: 'blur' }],
        countryName: [{ required: true, message: this.$t('SettingBaseDataCountry.table.countryNameText'), trigger: 'blur' }],
        enabledFlag: [{ required: true, message: '', trigger: 'blur' }],
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    afterUpload(res) {
      this.form.logo = res;
    },
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('SettingBaseDataCountry.table.editCountryDefinition') : this.$t('SettingBaseDataCountry.table.addCountryDefinition'));
      this.form = Object.assign(getDefaultForm(), info || {});
    },

    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
      }

      if (this.isEdit) {
        this.updateApi(API_DATA);
      } else {
        this.addApi(API_DATA);
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },
    addApi(API_DATA) {
      baseDataApi.addCountry(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    updateApi(API_DATA) {
      baseDataApi.updateCountry(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
